// @ts-nocheck
import React from 'react';
import Orders from 'components/access/Orders';

const PenlyAccess = () => (
    <Orders />
);

export default PenlyAccess;
